<template>
    <div>
        <div v-bind:style="{height:navBarHeight+'px'}" class="top-nav-bar-container">
            <div v-on:click="scrollToAbout" class="top-nav-bar-menu">
                <a>.about</a>
            </div>
            <div v-on:click="scrollToSkills" class="top-nav-bar-menu">
                <a>.skills</a>
            </div>
            <!-- <div v-on:click="scrollToProjects" class="top-nav-bar-menu">
                <a>.projects</a>
            </div> -->
            <div v-on:click="scrollToContacts" class="top-nav-bar-menu">
                <a>.contacts</a>
            </div>
        </div>
        <div v-bind:style="{height:bottomBarHeight+'px'}" class="bottom-nav-bar-container">
            <span>
                <div v-on:click="scrollToAbout" class="top-nav-bar-menu">
                    <font-awesome-icon icon="user"/>
                </div>
                <div v-on:click="scrollToSkills" class="top-nav-bar-menu">
                    <font-awesome-icon icon="tasks"/>
                </div>
                <!-- <div v-on:click="scrollToProjects" class="top-nav-bar-menu">
                    <font-awesome-icon icon="book"/>
                </div> -->
                <div v-on:click="scrollToContacts" class="top-nav-bar-menu">
                    <font-awesome-icon icon="envelope"/>
                </div>
            </span>
        </div>
        <div class="header-container">
            <div class="header">
                <a v-if="!scrolled" id="header-hello-name">Hi, I'm <a id="header-highlight-name">Michael Amadheo</a></a>
                <a v-else id="header-hello-name">Wow, back so soon?</a>
                <a v-if="!scrolled" id="header-my-job">I'm a mobile and web front-end developer</a>
                <a v-else id="header-give-call">Let's dive in a little more</a>
                <button v-on:click="scrollToAboutFromStart" class="start-tour-button">
                    {{scrolled===false?"Let's start the Tour":"Continue the tour"}}
                    <font-awesome-icon id="arrow-icon" icon="arrow-right"/>
                </button>
            </div>
        </div>
        <div ref="introduction" class="introduction-container">
            <div class="introduction">
                <img id="profile-image" src="../assets/michaelblank.png">
                <a id="introduction-title">About me</a>
                <a id="introduction-content">Hi, I'm Michael Amadheo. I majored in Informatics Engineering
                (also related to Computer Science) and graduated from Gunadarma University in 2018.
                currently i'm working as a Front-end Mobile App Developer.
                </a>
                <a id="introduction-content-2">I love to implement designs to a Mobile or Web user interface, 
                Let's say that i'm a painter with a little bit of technology applied
                </a>
                <a id="introduction-content-2">If i'm not developing something, you can find me playing music or even creating one!
                </a>

            </div>
        </div>
        <div ref="skills" class="skills-container">
            <div class="skills">
                <div>
                    <span id="ico-js">
                        <div>
                            <font-awesome-icon :icon="[ 'fab', 'js-square' ]"/>
                            <a class="skills-name">Javascript</a>
                        </div>
                    </span>
                    <span id="ico-html">
                        <div>
                            <font-awesome-icon :icon="[ 'fab', 'html5' ]"/>
                            <a class="skills-name">HTML5</a>
                        </div>
                    </span>
                    <span id="ico-css">
                        <div>
                            <font-awesome-icon :icon="[ 'fab', 'css3-alt' ]"/>
                            <a class="skills-name">CSS3</a>
                        </div>
                    </span>
                    <span id="ico-react">
                        <div>
                            <font-awesome-icon :icon="[ 'fab', 'react' ]"/>
                            <a class="skills-name">React.js</a>
                        </div>
                    </span>
                    <span id="ico-vue">
                        <div>
                            <font-awesome-icon :icon="[ 'fab', 'vuejs' ]"/>
                            <a class="skills-name">Vue.js</a>
                        </div>
                    </span>
                    <span id="ico-android">
                        <div>
                            <font-awesome-icon :icon="[ 'fab', 'android' ]"/>
                            <a class="skills-name">Android</a>
                        </div>
                    </span>
                    <span id="ico-react-native">
                        <div>
                            <font-awesome-icon :icon="[ 'fab', 'react' ]"/>
                            <a class="skills-name">React Native</a>
                        </div>
                    </span>
                    <span id="ico-node">
                        <div>
                            <font-awesome-icon :icon="[ 'fab', 'node-js' ]"/>
                            <a class="skills-name">Node.js</a>
                        </div>
                    </span>
                    <span id="ico-git">
                        <div>
                            <font-awesome-icon :icon="[ 'fab', 'git-square' ]"/>
                            <a class="skills-name">Git</a>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <!-- <div ref="projects" class="portfolio-container">
            <div class="portfolio">
                <a>
                    Wew
                </a>
            </div>
        </div> -->
        <div ref="contacts" class="footer">
            <a>michael amadheo © 2021</a>
            <span>
                <a href="https://www.linkedin.com/in/michael-amadheo-211184171/" target="_blank">
                    <font-awesome-icon :icon="[ 'fab', 'linkedin' ]"/>
                </a>
                <a href="https://www.instagram.com/mich.madheo/" target="_blank">
                    <font-awesome-icon :icon="[ 'fab', 'instagram' ]"/>
                </a>
                <a href="https://github.com/michmadheo/" target="_blank">
                    <font-awesome-icon :icon="[ 'fab', 'github' ]"/>
                </a>
                <a href="https://bitbucket.org/michmadheo/" target="_blank">
                    <font-awesome-icon :icon="[ 'fab', 'bitbucket' ]"/>
                </a>
            </span>
        </div>
    </div>
</template>

<script>

export default{
    created () {
        setTimeout(function(){
            window.scrollTo(0,0);
        }, 100);
        document.body.style.overflow = "hidden"
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    name:'Home',
    data(){
        return{
            tes:'hello',
            link:'https://www.linkedin.com/in/michael-amadheo-211184171/',
            scrollPos: 0,
            navBarHeight:0,
            bottomBarHeight:0,
            scrolled: false,
            startPage: true,
        }
    },
    methods:{
        handleScroll () {
            this.scrollPos = window.scrollY
            if(window.scrollY < 500){
                this.navBarHeight = 0
                this.bottomBarHeight = 0
            }
            else{
                this.navBarHeight = 60
                this.bottomBarHeight = 45
                if(!this.scrolled && !this.startPage){
                    this.scrolled = true
                }
            }
        },
        scrollToAboutFromStart: function(){
            document.body.style.overflow = "unset";
            let div = this.$refs.introduction;
            div.scrollIntoView({behavior:"smooth"});
            console.log(this.$refs.introduction)
            this.startPage = false
        },
        scrollToAbout: function(){
            let div = this.$refs.introduction;
            div.scrollIntoView({behavior:"smooth"});
        },
        scrollToSkills: function(){
            let div = this.$refs.skills;
            div.scrollIntoView({behavior:"smooth"});
        },
        scrollToProjects: function(){
            let div = this.$refs.projects;
            div.scrollIntoView({behavior:"smooth"});
        },
        scrollToContacts: function(){
            let div = this.$refs.contacts;
            div.scrollIntoView({behavior:"smooth"});
        }
    }
}
</script>

<style>
 @import '../Home.css';
</style>